import React from 'react'
import {
    FaFacebook,
    FaInstagram,
    FaGithub
} from 'react-icons/fa';
import {
    FooterContainer,
    FooterWrap,
    SocialMedia,
    SocialMediaWrap,
    SocialLogo,
    SocialIcons,
    SocialIconLink
} from './FooterElements';


const Footer = () => {
    return (
        <FooterContainer>
            <FooterWrap>
                <SocialMedia>
                    <SocialMediaWrap>
                        <SocialLogo to ="/">Kovács Bálint Hunor</SocialLogo>
                        <SocialIcons>
                            <SocialIconLink href="https://www.facebook.com/kovacsbalinthunor" target="_blank" 
                            aria-label="Facebook" rel="noopener noreferrer">
                                <FaFacebook/>
                            </SocialIconLink>
                            <SocialIconLink href="https://www.instagram.com/wa_watashi_hiromitsu/" target="_blank" 
                            aria-label="Instagram" rel="noopener noreferrer">
                                <FaInstagram/>
                            </SocialIconLink>
                            <SocialIconLink href="https://github.com/MemerGamer" target="_blank" 
                            aria-label="Githubgith" rel="noopener noreferrer">
                                <FaGithub/>
                            </SocialIconLink>
                        </SocialIcons>
                    </SocialMediaWrap>
                </SocialMedia>
            </FooterWrap>
        </FooterContainer>
    )
}

export default Footer